<mat-expansion-panel [togglePosition]="togglePosition" class="theme-{{theme}}" [class.hide-shadow]="hideShadow" [hideToggle]="theme === 'dark'" (opened)="onOpened()" (closed)="onClosed()">
	<mat-expansion-panel-header>
		<mat-panel-title [ngClass]="{'channel-panel-title' : suffixText}">
			<span *ngIf="entity?.id" class="thumb" [innerHTML]="entity | thumbnail: 64:36 | async"></span>
			<span *ngIf="entity && !entity.id" class="thumb"><i class="fa-solid fa-image"></i></span>
			<span class="title-text">{{ title }}</span>
		</mat-panel-title>
		<mat-panel-description>
			{{ description }}
			<ng-content select=".bb-collapsible-buttons">
			</ng-content>
			<i *ngIf="theme === 'dark'" class="fas fa-caret-circle-down" [style.transform]="isOpen ? 'rotate(180deg)' : 'rotate(0deg)'"></i>
		</mat-panel-description>
	</mat-expansion-panel-header>
	<ng-content></ng-content>
</mat-expansion-panel>
